import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { IonicModule } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { FormsModule } from '@angular/forms';
import { AuthGuard } from "./common/guard/auth.guard";
import { File } from "@awesome-cordova-plugins/file/ngx";
import { MediaCapture } from "@awesome-cordova-plugins/media-capture/ngx";
import { NgCircleProgressModule } from 'ng-circle-progress';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { WebIntent} from '@ionic-native/web-intent/ngx';
import { QRCodeModule } from 'angularx-qrcode';
@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    IonicModule.forRoot({
      innerHTMLTemplatesEnabled:true
    }),
    QRCodeModule,
    IonicStorageModule.forRoot(),
    NgCircleProgressModule.forRoot({
      "backgroundPadding": 2,
      "radius": 125,
      "space": -10,
      "toFixed": 0,
      "maxPercent": 100,
      "outerStrokeGradient": true,
      "outerStrokeWidth": 10,
      "outerStrokeColor": "#4882c2",
      "outerStrokeGradientStopColor": "#53a9ff",
      "innerStrokeColor": "#e7e8ea",
      "innerStrokeWidth": 10,
      "animateTitle": false,
      "titleColor":"#444444",
      "animationDuration": 1000,
      "showTitle": true,
      "showSubtitle": true,
      "responsive":true,
      "showBackground": true,
      "clockwise": true,
      "startFromZero": true,
      "lazy": false})
    // ServiceWorkerModule.register('ngsw-worker.js', {
    //   enabled: environment.production
    // })
  ],
  declarations: [AppComponent],
  providers: [InAppBrowser, AndroidPermissions, LocationAccuracy, Geolocation, AuthGuard,WebIntent, File, MediaCapture],
  bootstrap: [AppComponent]
})
export class AppModule {}
